module.exports = __webpack_public_path__ + "static/FL3-be8ca71da8aa1897ac4265e12189150d.png";